import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type {
  LossAndDamageClaimComment,
  LossAndDamageClaimFile,
  LossAndDamageClaimItem,
  LossAndDamageClaimSettlement,
} from '@/views/screens/Claims/types';

export interface SaveClaimData {
  claimKey: number;
  [key: string]: unknown; // Allow additional fields from form
  claimComment?: LossAndDamageClaimComment[];
  claimFile?: LossAndDamageClaimFile[];
  claimItem?: LossAndDamageClaimItem[];
  claimSettlement?: LossAndDamageClaimSettlement[];
}

export const saveClaimAPI = (data: SaveClaimData) => {
  return axiosInstance.request({
    data,
    method: 'post',
    url: `${API.LOSS_AND_DAMAGE}/SaveClaim`,
  });
};

export type SaveClaimResponse = number; // Returns claimKey

export const saveClaim = async (data: SaveClaimData): Promise<SaveClaimResponse> => {
  const response: AxiosResponse<SaveClaimResponse> = await saveClaimAPI(data);
  return response.data;
};
